import { useCallback } from 'react';
import analytics, { trackEvent } from '../utils/analytics';

export const useAnalytics = () => {
  const trackLinkClick = useCallback((href, text, surface = 'link') => {
    trackEvent('external_link_click', {
      href,
      label: text || '',
      surface,
    });
  }, []);

  const trackDownload = useCallback((filename, type = 'unknown') => {
    trackEvent('external_link_click', {
      href: filename,
      label: type,
      assetType: type,
      surface: 'download',
    });
  }, []);

  const trackResumeView = useCallback((version) => {
    trackEvent('resume_open', {
      href: version ? `/api/download/resume?version=${version}` : '/api/download/resume',
      label: 'Resume',
      surface: 'resume',
      resumeVersion: version || '',
      assetType: 'resume',
    });
  }, []);

  const trackSocialClick = useCallback((platform, action = 'click') => {
    trackEvent('social_click', {
      platform,
      action,
      label: platform || '',
      surface: 'social',
    });
  }, []);

  const trackContactAttempt = useCallback((method, details = {}) => {
    trackEvent('contact_click', {
      method,
      label: method || '',
      surface: 'contact',
      ...details,
    });
  }, []);

  const trackProjectInteraction = useCallback((projectName, action = 'click') => {
    trackEvent('external_link_click', {
      label: projectName || '',
      surface: 'project',
      action,
    });
  }, []);

  const trackPaperPdfOpen = useCallback((paperSlug, paperTitle = '') => {
    trackEvent('paper_pdf_open', {
      href: paperSlug ? `/api/download/paper?slug=${paperSlug}` : '/api/download/paper',
      label: 'PDF',
      surface: 'experiments',
      paperSlug: paperSlug || '',
      paperTitle,
      assetType: 'paper_pdf',
    });
  }, []);

  const trackPaperCodeClick = useCallback((paperSlug, paperTitle = '', href = '') => {
    trackEvent('paper_code_click', {
      href,
      label: 'Code',
      surface: 'experiments',
      paperSlug: paperSlug || '',
      paperTitle,
      assetType: 'paper_code',
    });
  }, []);

  return {
    trackLinkClick,
    trackDownload,
    trackResumeView,
    trackSocialClick,
    trackContactAttempt,
    trackProjectInteraction,
    trackPaperPdfOpen,
    trackPaperCodeClick,
    trackEvent,
    getUserProfile: () => analytics.getUserProfile(),
    getDetailedStats: () => analytics.getDetailedStats()
  };
}; 
